import { Component, ViewEncapsulation } from '@angular/core';
import { CommonLibrary } from '../../core/common-library';
import { PendingDiscountDetails } from '../DTOs/pending-discount-details';
import { UpdatePendingDiscountRequest } from '../DTOs/update-pending-discount-request';
import { MemberDiscountService } from '../member-discount.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-edit-discount-modal',
  templateUrl: './edit-discount-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditDiscountModalComponent {

    protected readonly CommonLibrary = CommonLibrary;

    constructor(private pendingDiscountService: MemberDiscountService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private route: ActivatedRoute
        , private router: Router
        , private activeModal: NgbActiveModal) { }

    discount: PendingDiscountDetails;

    getDateString(submissionDate: Date) {
        return CommonLibrary.formatDateIntoString(submissionDate);
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }

    UpdateDiscount() {
        const req = new UpdatePendingDiscountRequest();
        req.redemptionLimit = this.discount.redemptionLimit;
        req.endDate = new Date(this.discount.endDate);
        req.startDate = new Date(this.discount.startDate);
        req.value = this.discount.value;
        req.discountId = this.discount.discountId;

        this.pendingDiscountService.updateDiscount(req).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.notificationService.success("Discount successfully updated.");
                this.activeModal.close();
            }
        });;
    }
}
